// @flow
import 'react-dates/initialize'

import { DriftAnalytics } from '@driftt/dds.analytics'
import { ThemeProvider as DDSThemeProvider, ToastProvider } from '@driftt/dds'
import React, { useEffect } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { useSelector } from 'react-redux'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import SubNavigation from 'components/SubNavigation'
import ContactDetails from 'layouts/ContactDetails'
import Contacts from 'layouts/Contacts'
import CSVImport from 'layouts/Imports/CSVImport'
import HubspotImport from 'layouts/Imports/HubspotImport'
import ImportLogs from 'layouts/Imports/ImportLogs'
import MarketoImport from 'layouts/Imports/MarketoImport'
import MarketoImportEventLogs from 'layouts/Imports/MarketoImportEventLogs'
import NewImport from 'layouts/Imports/NewImport'
import PardotImport from 'layouts/Imports/PardotImport'
import AllSegments from 'layouts/Segments'
import Settings from 'layouts/Settings'
import SingleSegmentMembers from 'layouts/SingleSegment'
import DuplicatesList from 'pages/DuplicatesList'
import Merge from 'pages/Merge'

import 'react-dates/lib/css/_datepicker.css'
import './style.css'

const queryClient = new QueryClient()


const AppLayout = () => {
  const currentUser = useSelector((state) => state.user ?? {})
  useEffect(() => {
    DriftAnalytics.initialize({ user: currentUser })
  }, [currentUser])

  return (
    <QueryClientProvider client={queryClient}>
      <DDSThemeProvider>
        <ToastProvider>
          <Router basename="/contacts">
            <div className="contacts-layout__wrapper">
              <SubNavigation/>
              <div className="contacts-layout">
                <Switch>
                  <Route path="/imports/hubspot" component={HubspotImport}/>
                  <Route path="/imports/pardot" component={PardotImport}/>
                  <Route path="/imports/marketo" component={MarketoImport}/>
                  <Route path="/imports/csv" component={CSVImport}/>
                  <Route path="/imports/logs/marketo/:jobId" component={MarketoImportEventLogs}/>
                  <Route path="/imports/logs" component={ImportLogs}/>
                  <Route path="/imports" component={NewImport}/>
                  <Route
                    exact
                    path="/duplicates"
                    component={DuplicatesList}
                  />
                  <Route
                    path="/duplicates/merge/:email"
                    component={Merge}
                  />
                  <Route path="/segments/:segmentId" component={SingleSegmentMembers}/>
                  <Route path="/segments" component={AllSegments}/>
                  <Route path="/contact-settings" component={Settings}/>
                  <Route exact path="/details/:id"
                         component={ContactDetails}/>
                  <Route exact path="/"
                         component={Contacts}/>
                  <Route exact path="/:id"
                         component={Contacts}/>
                </Switch>
              </div>
            </div>
          </Router>
        </ToastProvider>
      </DDSThemeProvider>
    </QueryClientProvider>
  )
}

export default AppLayout
